module.exports = __webpack_public_path__ + "img/metroidvania08.615c45ab.gif";